export default __webpack_public_path__ + "static/media/proxima-nova-light.3839175a.woff2";